window['linkCard'] = function (callbackSuccess, callbackError) {
    var start = Date.now();

    var $form = $('#mainForm');
    $form.addClass('in-progress');

    var jsonData = {
        cardNumberPart1: $('#card-part1').val(),
        cardNumberPart2: $('#card-part2').val(),
        cardNumberPart3: $('#card-part3').val(),
        displayErrorMessages: ($form.data('step')) ? true : false,
        loyaltyProgram: $('#cardLoyaltyProgram').val(),
        postalCode: $('#postal-code').val(),
    };
    if($('#opt-in-newsletter').length) {
        jsonData.isOptInNewsletter = $('#opt-in-newsletter').prop('checked');
    }

    //call ajax to controller on a valid link card
    TINK.sessionAjax({
        url: '/' + lang + '/account/link-card',
        method: 'POST',
        headers: {
            'Accept-Language': lang
        },
        data: JSON.stringify(jsonData),
        contentType: 'application/json; charset=utf-8',
        success: function (data) {
            var delta = Date.now() - start;
            setTimeout(function () {
                if (data && data.errorMessages) {
                    onError(data.errorMessages, data.erroneousFields, callbackError);
                } else {
                    window.localStorage.setItem("justSignedUp", "true");
                    //set localStorage to handle address-synchronization form
                    window.localStorage.setItem('justLinkedCard', 'true');
                    onSuccess(data, callbackSuccess, jsonData.isOptInNewsletter);
                }
            }, Math.max(0, TINK.timeoutDelay - delta));
        },
        error: function (jqXHR) {
            handleLinkError(jqXHR, start);
            TINK.redirectIfConflict(jqXHR);
        }
    });
};

window['unlinkCard'] = function () {
    var start = Date.now();

    $('#mainForm').addClass('in-progress');

    //call ajax to controller on a valid link card
    $.ajax({
        url: '/' + lang + '/account/unlink-card',
        method: 'DELETE',
        headers: {
            'Accept-Language': lang
        },
        success: function () {
            var delta = Date.now() - start;
            setTimeout(function () {
                $('#mainForm').removeClass('in-progress');
                $('#unlinkForm').addClass('hide');
                $('#linkForm').removeClass('hide');
                $('#myCard #replace').addClass('hide');
                $('.mm-card--title').attr('tabindex', '0').focus();
                hideLinkError();
            }, Math.max(0, TINK.timeoutDelay - delta));
        },
        error: function (jqXHR) {
            handleLinkError(jqXHR, start);
            TINK.redirectIfConflict(jqXHR);
        }
    });
};

function onError(errorMessages, erroneousFields, callbackError) {
    if (typeof callbackError === 'function') {
        callbackError();
    } else {
        showLinkError(errorMessages, erroneousFields);
    }
}

function onSuccess(data, callbackSuccess, isOptInNewsletter) {
    _push_custom_event_to_GA4('card_link');
    if (isOptInNewsletter) {
        _push_custom_event_to_GA4(
            'newsletter_subscribe',
            'newsletter_name', ga4LoyaltyProgram
        );
    }
    if (typeof callbackSuccess === 'function') {
        callbackSuccess();
    } else {
        onLinkCompleted(data);
    }
}

function showLinkError(messages, fields) {
    $('#mainForm').removeClass('in-progress');

    var $errorMsg = $('#error-msg');
    $errorMsg.empty();
    var $postalCodeDiv = $('#postalCodeDiv');
    var $postalCodeErrorDiv = $('#postalCodeErrorDiv');
    var $postalCodeErrorInput = $('#postal-code');
    var $part1ErrorLabel = $('#card-part1');
    var $part2ErrorLabel = $('#card-part2');
    var $part3ErrorLabel = $('#card-part3');
    var $postalCodeErrorLabel = $('#postalCodeLabel');


    $.each(messages, function (index, value) {
        var $newErrorLink = $('<label class="error-message-label focusOnMyAnchor" aria-live="assertive">' + value + '</label>' + '<img src="/images/main/status/icon-error.svg" alt=""/>');
        if (fields[index] == 'postal-code') {
            $postalCodeDiv.append($newErrorLink);
            $postalCodeErrorInput.addClass('error-standard');
            $postalCodeErrorLabel.addClass('error-standard');
        } else {
            $postalCodeErrorDiv.append($newErrorLink);
            $part1ErrorLabel.addClass('error-standard');
            $part2ErrorLabel.addClass('error-standard');
            $part3ErrorLabel.addClass('error-standard');
        }
    });
    $errorMsg.removeClass('hide').attr('tabindex', '0').focus();
}

function hideLinkError() {
    var $errorMsg = $('#error-msg');
    $errorMsg.empty();
    $errorMsg.addClass('hide');
}

function showLinkSuccessMsg() {
    $('#alert').removeClass('hide').attr('tabindex', '0').focus();
}

function hideLinkSuccessMsg() {
    $('#alert').addClass('hide');
}

function onLinkCompleted(data) {
    $('#mainForm').removeClass('in-progress');
    $('#card-part1').val('');
    $('#card-part2').val('');
    $('#card-part3').val('');
    $('#opt-in-newsletter').prop('checked', false);

    displayMyCard(data);
}

function displayMyCard(data) {
    if (inCheckoutOrCart) {
        $('#mainForm').remove();
        $('.mmCard-form-wrapper').addClass('hide');
        if (typeof checkoutStep !== 'undefined') {
            if (checkoutStep === 0) {
                displayCouponsBloc();
                displayHYFBloc();
            } else if (checkoutStep === 2) {
                Checkout.showCheckoutAccount();
            }
        }
        CartSummary.updateCartSummary();
    } else {
        showLinkSuccessMsg();
        $('#linkForm').addClass('hide');
        $('#unlink').removeClass('hide');
        hideLinkError();
    }

    $('#cardNumber').text(data.cardNumber);

    if (data.isDigitalCard && data.isDigitalCard == true) {
        $('#digital-card-wrapper').removeClass('hide');
        $('#physical-card-wrapper').addClass('hide');
        $('#physical-card-description-wrapper').addClass('hide');
        $('#myCard #replace').addClass('hide');

        $('.mcp--barcode').find('.inject-barcode').text(data.cardNumber);
        injectBarCodes();
    } else {
        $('#digital-card-wrapper').addClass('hide');
        $('#physical-card-wrapper').removeClass('hide');
        $('#physical-card-description-wrapper').removeClass('hide');
        $('#myCard #replace').removeClass('hide');
    }

    $('#myCard').removeClass('hide');
    $('#alert,.mm-card--success .heading-5').first().attr('tabindex', '0').focus();
}

function injectBarCodes() {
    $('.inject-barcode').each(function () {
        $(this).barcode($(this).text(), "code128", {
            barWidth: 1,
            barHeight: 60
        });

        $(this).removeClass('hide');
    });
}

function displayUnlinkForm() {
    hideLinkError();
    hideLinkSuccessMsg();
    $('#myCard').addClass('hide');
    $('#unlinkForm').removeClass('hide');
    $('#unlink').addClass('hide');
    $('#replaceForm').addClass('hide');
}

function displayReplaceForm() {
    $('#myCard').addClass('hide');
    $('#unlinkForm').addClass('hide');
    $('#unlink').addClass('hide');
    $('#replaceForm').removeClass('hide');
}

function displayReplaceFormSuccess() {
    var $replaceForm = $('#replaceForm');
    $replaceForm.parent().removeClass('in-progress relative');

    $('#myCard').addClass('hide');
    $('#unlinkForm').addClass('hide');
    $('#unlink').addClass('hide');
    $replaceForm.addClass('hide');
    $('#replaceFormSuccess').removeClass('hide');
}

function resetOriginalMMView() {
    $('#unlinkForm').addClass('hide');
    $('#replaceForm').addClass('hide');
    $('#replaceFormSuccess').addClass('hide');
    $('#unlink').removeClass('hide');
    $('#myCard').removeClass('hide');
}

function replaceCard() {
    $('#replaceForm').parent().addClass('in-progress relative');

    $.ajax({
        url: '/' + lang + '/account/card/replace',
        method: 'POST',
        headers: {
            'Accept-Language': lang
        },
        success: function () {
            setTimeout(displayReplaceFormSuccess, 500);
        },
        error: function (jqXHR) {
            if (!TINK.redirectIfConflict(jqXHR)) {
                location.reload();
            }
        }
    });
}

function handleLinkError(jqXHR, startTime) {
    if (!!jqXHR.responseJSON && !!jqXHR.responseJSON.errorMessages) {
        if (typeof userLoyaltyProgram !== 'undefined') {
            pushDataLayerLinkingCardErrorMyAccount(userLoyaltyProgram, jqXHR.responseJSON.errorMessages[0]);
        }
        var delta = Date.now() - startTime;
        var delay = Math.max(0, TINK.timeoutDelay - delta);
        setTimeout(function () {
            showLinkError(jqXHR.responseJSON.errorMessages, jqXHR.responseJSON.erroneousFields);
        }, delay);
    }
}

var bindLinkCardButton = function () {
    $('#link-card-button').click(function () {
        linkCard();
    });
};

var bindLinkCardInput = function () {
    var $form = $('#mainForm');
    if ($form.length) {
        $form.find('[data-autofocus="container"]').autofocus_input();
    }
};

$(document).ready(function () {
    bindLinkCardButton();

    $('#unlink-card-button')
        .unbind('click')
        .on('click', function () {
            unlinkCard();
        });

    $('#unlink').click(function () {
        displayUnlinkForm();
    });

    $('#cancel-unlink').click(function () {
        $('#linkForm').addClass('hide');
        $('#unlinkForm').addClass('hide');
        $('#unlink').removeClass('hide');
        $('#myCard').removeClass('hide');
        hideLinkError();
    });

    $('#replace').click(function () {
        displayReplaceForm();
    });

    $('#replace-card-button').click(function () {
        replaceCard();
    });

    $('#replace-card-success-button').click(function () {
        resetOriginalMMView();
    });

    $('#cancel-replace').click(function () {
        $('#unlinkForm').addClass('hide');
        $('#replaceForm').addClass('hide');
        $('#unlink').removeClass('hide');
        $('#myCard').removeClass('hide');
        hideLinkError();
    });

    // Accessibility
    $('#mmCardFirst5Numbers').click(function () {
        set(true);
        $('#mmCard6to8Numbers').removeClass('focus');
        $('#mmCardLastNumber').removeClass('focus');
        $('#mmCardFirst5Numbers').addClass('focus');
        return false;
    });

    $('#mmCard6to8Numbers').click(function () {
        set(true);
        $('#mmCardFirst5Numbers').removeClass('focus');
        $('#mmCardLastNumber').removeClass('focus');
        $('#mmCard6to8Numbers').addClass('focus');
        return false;
    });

    $('#mmCardLastNumber').click(function () {
        set(true);
        $('#mmCard6to8Numbers').removeClass('focus');
        $('#mmCardFirst5Numbers').removeClass('focus');
        $('#mmCardLastNumber').addClass('focus');
        return false;
    });
});
